import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Container, Paper, Typography } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import { RZP_KEY } from "../../globals/const";
import {
  capturePayment,
  createOrder,
  getAvailablePlans,
} from "../../api/subscription";
import { CustomTitle } from "../../components/Custom/CustomTypography";

export default function CreateSubscription() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    fetchPlans();

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const fetchPlans = async () => {
    const plans = await getAvailablePlans();
    console.log(plans);
    setPlans(plans);
  };

  const verifyPayment = async (payment_data) => {
    const successful = capturePayment(
      payment_data.razorpay_order_id,
      payment_data.razorpay_payment_id,
      payment_data.razorpay_signature
    );
    if (successful) {
      alert("Payment successful");
      navigate("/my-subscriptions");
    }
  };

  const handleSubscribe = async (plan_code) => {
    const result = await createOrder(plan_code);
    const orderId = result.order_id;

    const options = {
      key: RZP_KEY,
      currency: "INR",
      name: "Farmapp subscription",
      description: "Subscribe to farmapp",
      image:
        "https://farmapp-stage.asqi.in/static/media/FarmAppLogo.73816e8df129dc26c289.png",
      order_id: orderId,
      handler: function (response) {
        verifyPayment(response);
      },
    };
    let rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <>
      <CustomAppBar title={t("Create Subscription")} />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            spacing={2}
            style={{ marginTop: "10px" }}
          >
            <Grid item>
              <CustomTitle>{t("Available Plans")}</CustomTitle>
            </Grid>
            {plans.map((plan) => (
              <Grid item key={plan.plan_code}>
                <Paper style={{ padding: "10px" }}>
                  <Grid container alignItems="center">
                    <Grid item xs={8}>
                      <Typography variant="subtitle1">{plan.name}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        {t("Amount")}: ₹{plan.amount}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} container justifyContent="flex-end">
                      <CustomButton
                        onClick={() => handleSubscribe(plan.plan_code)}
                        hideIcon
                      >
                        {t("Subscribe")}
                      </CustomButton>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </div>
      </Container>
    </>
  );
}
